<template>
  <Tooltip v-bind="getBindValue">
    <template #content>
      <div class="kone-help-tooltip">
        {{ attrs.content }}
        <slot name="content"></slot>
      </div>
    </template>
    <slot></slot>
  </Tooltip>
</template>
<script lang="ts" setup>
import { useAttrs, computed, watch } from 'vue'
import { Tooltip } from 'tdesign-vue-next'

defineOptions({
  name: 'KoneTooltip'
})

const attrs = useAttrs()

const getBindValue = computed(() => ({ ...attrs }))

watch(
  () => attrs,
  () => {
    console.log('attrs', attrs)
  }
)
</script>

<style lang="less">
.kone-help-tooltip {
  width: 200px;
  background-color: var(--Primitives-color-blue-50) !important;
  color: var(--Primitives-color-blue-500) !important;
}

.t-tooltip .t-popup__content:has(.kone-help-tooltip) {
  background-color: var(--Primitives-color-blue-50) !important;
  color: var(--Primitives-color-blue-500) !important;
}
</style>
